import { z } from 'zod';
import { API } from '../..';

/**
 * POST /moyasar/webhook — Moyasar webhook receiver. Body shape is whatever
 * Moyasar sends; signature is verified against `MOYASAR_WEBHOOK_SECRET`.
 */
export const moyasarWebhookAPISchema = z.object({}).passthrough();
export type MoyasarWebhookAPI = API<
  z.infer<typeof moyasarWebhookAPISchema>,
  { received: true }
>;
